// pages/index/IntroSlider.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './IntroSlider.css';

// Define images from public/images folder
const IMAGES = [
  {
    id: 1,
    url: '/images/slide1.jpeg',
    alt: 'Mountain landscape'
  },
  {
    id: 2,
    url: '/images/slide2.jpeg',
    alt: 'Sea and coastline'
  },
  {
    id: 3,
    url: '/images/slide3.jpeg',
    alt: 'Forest path'
  }
];

const IntroSlider = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalSlides = IMAGES.length;

  const goToNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  }, [totalSlides]);

  const goToPrev = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  }, [totalSlides]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  // Auto-slide every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 4000);
    return () => clearInterval(interval);
  }, [goToNext]);

  const handleStart = () => {
    navigate('/register');
  };

  return (
    <div className="slider-container">
      <div className="slide-wrapper">
        {/* Current slide image */}
        <img
          src={IMAGES[currentIndex].url}
          alt={IMAGES[currentIndex].alt}
          className="slide-image"
        />
        <div className="slide-overlay"></div>

        {/* Navigation arrows */}
        <button
          className="nav-arrow nav-arrow-left"
          onClick={goToPrev}
          aria-label="Previous slide"
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        <button
          className="nav-arrow nav-arrow-right"
          onClick={goToNext}
          aria-label="Next slide"
        >
          <i className="fas fa-chevron-right"></i>
        </button>

        {/* Dot indicators */}
        <div className="indicators">
          {IMAGES.map((_, idx) => (
            <button
              key={idx}
              className={`dot ${idx === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>

        {/* Start button - bottom right corner */}
        <button className="start-btn" onClick={handleStart}>
          <i className="fas fa-rocket"></i> Start
        </button>
      </div>
    </div>
  );
};

export default IntroSlider;